<script>
import Vue from "vue";
import VTooltip from "v-tooltip";

Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfRaporGiris from "@/models/StrPerfRaporGiris";

import "v-tooltip/dist/v-tooltip.css";

export default {
  mixins: [Api, Sabit, StrPerfRaporGiris],
  props: [
    "TabloId",
    "BirimId",
    "DonemId",
    "Sorgulama",
    "AltDonemId",
    "AllTable",
  ],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      TabloVerileri: [],
      TabloDetayVerileri: [],

      Veriler: [],
      FormData: [],
      AltDonemler: [],
      gostergelistesi: [],
      Degerlendirme: null,
      donem_yili: "",
      deger: "",
      aciklama: "",
      bugun: null,
      hostname: null,
      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      },
      tumTablolar: false,
      AllTableData: [],
    };
  },

  watch: {
    Sorgulama() {
      this.Get();
    },
    TabloId() {
      this.Get();
    },
  },

  methods: {
    Get() {
      this.bugun = new Date();
      this.TabloVerileri = [];
      this.TabloDetayVerileri = [];



      let Filter =
        "&Tabloid=" +
        this.TabloId +
        "&Ustdonemid=" +
        this.DonemId +
        "&DonemAciklama=" +
        true;

      this.ActionsFilterGet({
        Service: "StrRaporlama/GetStratejikPlanIzlemeFormuAylik",
        Page: this.Page,
        Filter: Filter,
      }).then((res3) => {
        this.TabloVerileri = res3.Data;

      });


    }, 
GostegeyiBul(Data,Gosterge) {
  if (!Data || !Array.isArray(Data.TabloDetay)) return "";

  const kayit = Data.TabloDetay.find(item => 
    item.Gostergesi === Gosterge
  );

  return kayit ? kayit.Gerceklesme : "";
},


    ExcelExport(table, name) {
      if (!table.nodeType) table = this.$refs.Izlemetablosu;
      var html = table.innerHTML;
      var ctx = { worksheet: name || "Worksheet", table: html };
      var a = document.createElement("a");
      a.href = this.uri + this.base64(this.format(this.template, ctx));
      a.download = name + ".xls";
      a.click();
    },
  },
  computed: {},

  created() {
    this.Get();
    this.hostname = this.$config.COOKIES_DOMAIN;
  },
};
</script>
<template>
  <div>
    <div>
      <div class="text-sm-end">
   
        <button type="button" class="btn btn-warning btn-rounded mb-2 me-2" @click="get_tum_tablolar()"
          v-if="tumTablolar == true">
          Seçili Tablo İçin Getir
        </button>
        <button type="button" class="btn btn-success btn-rounded mb-2 me-2"
          @click="ExcelExport('İzleme Tablosu', 'İzleme Tablosu')">
          <i class="mdi mdi-file-export-outline me-1"></i>
          Excel'e Aktar
        </button>
      </div>

      <div ref="Izlemetablosu" v-if="tumTablolar == false">
        <table class="col-md-12">
          <tbody>
            <tr>
              <td>
                <div>
                  <table style="border: 1px solid; border-collapse: collapse;" border="1"
                    class="table  table-md table-bordered border-success mb-0">
                    <tbody>
                      <tr>
                        <th colspan="6"
                          style="background-color:rgb(7, 156, 165);color:white;font-weight:bold;text-align:center;">
                          Performans Göstergesi Gerçekleştirmeleri İzleme Formu (Aylık)
                        </th>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr>
                        <td style="background-color:rgb(7, 156, 165); color:white;font-weight:bold;" scope="col"
                          colspan="1">
                          {{ $t("IzlemeTablosu.Table.Amac") }}
                        </td>
                        <td colspan="5">
                          {{ TabloVerileri.DonemDetay[0].Amac }}
                        </td>
                      </tr>
                    </tbody>
                    <tbody>

                      <tr>
                        <td style="background-color:rgb(7, 156, 165); color:white;font-weight:bold;" scope="col"
                          colspan="1">
                          {{ $t("IzlemeTablosu.Table.TabloAdi") }}
                        </td>
                        <td colspan="5">{{ TabloVerileri.DonemDetay[0].Hedef }}</td>
                      </tr>

                    </tbody>

                    <tbody>
                      <tr>
                        <td style="background-color:rgb(7, 156, 165); color:white;font-weight:bold;" scope="col"
                          colspan="1">
                          {{ $t("IzlemeTablosu.Table.PerformansHedefi") }}
                        </td>
                        <td colspan="5" style="text-align: left;">
                          {{
                            TabloVerileri.DonemDetay[0].HedefPerformans | formatNoktaToVirgul
                          }}
                        </td>
                      </tr>

                    </tbody>
                    <tbody> 
                      <tr>
                        <td style="background-color:rgb(7, 156, 165); color:white;font-weight:bold;" scope="col"
                          colspan="1">
                          {{ $t("IzlemeTablosu.Table.SorumluBirim") }}
                        </td>
                        <td colspan="5">{{ TabloVerileri.DonemDetay[0].SorumluBirimAdi }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
            <tr>
              <td>  
                <div class="table-responsive">
                  <table style="border: 1px solid; border-collapse: collapse;" border="1"
                    class="table table-md table-bordered border-success mb-0">
                    <tbody>
                      <tr>
                        <td style="background-color:rgb(7, 156, 165);color:white;font-weight: bold;">
                          Göstergesi
                        </td>
                        <td v-for="(item, index) in TabloVerileri.DonemDetay || []" :key="index"
                          style="background-color:rgb(7, 156, 165);color:white;font-weight: bold;">
                          {{ item.Donem }}
                        </td>


                      </tr>
                    </tbody>
                    <tbody>
                      <template v-for="(TabloDetay, index) in  TabloVerileri.DonemDetay[0].TabloDetay || []">
                        <tr :key="index">
                          <td>{{ TabloDetay.Gostergesi }}</td>
                         
                          <td v-for="(item, index) in TabloVerileri.DonemDetay || []" :key="index">
                 
                            {{ GostegeyiBul(item, TabloDetay.Gostergesi) | formatNoktaToVirgul }}
                          </td>
                          
                        </tr>
                      </template>
                    </tbody>

                  </table>
                  <table></table>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
      </div>

    </div>
  </div>
</template>
